<template>
  <div class="car-details" v-loading="oLoading.detail">
    <p class="title">入库验车</p>
    <section class="item">
      <QS-h4-title title="交接信息" />
      <QS-column-box
        :labelWidth="130"
        :source="stockInfoVo"
        :list="stockKeyList"
        separator=":"
      />
    </section>
    <section>
      <QS-h4-title title="验车信息" />
      <div class="carPhoto-box">
        <div class="carPhoto-title">验车交接文件:</div>
        <div class="photo-box" v-if="stockInfoVo.inspectionAttachment">
          <div
            v-for="(item, index) in stockInfoVo.inspectionAttachment"
            :key="'inspectionAttachment' + index"
            class="photo-item"
          >
            <template v-if="item.url">
              <div class="imgPhoto">
                <EnlargeImg :imgSrc="item.url" />
              </div>
              <div class="imgPhoto-title">说明：{{ item.remark || '--' }}</div>
            </template>
            <template v-else-if="item.urlList">
              <div style="display:flex">
                <div
                  class="imgPhoto"
                  v-for="(urlItem, index) in item.urlList"
                  :key="index"
                >
                  <EnlargeImg :imgSrc="urlItem.url" />
                </div>
              </div>
              <div class="imgPhoto-title">说明：{{ item.remark || '--' }}</div>
            </template>
            <template v-else>
              <span>--</span>
            </template>
          </div>
        </div>
      </div>

      <div class="carPhoto-box">
        <div class="carPhoto-title">车辆相关照片:</div>
        <div class="photo-box" v-if="stockInfoVo.photo">
          <div
            v-for="(item, index) in stockInfoVo.photo"
            :key="'photo' + index"
            class="photo-item"
          >
            <div style="display:flex">
              <div
                class="imgPhoto"
                v-for="(urlItem, index) in item.urlList"
                :key="index"
              >
                <EnlargeImg :imgSrc="urlItem.url" />
              </div>
            </div>
            <div class="imgPhoto-title" v-if="item.remark">
              说明：{{ item.remark }}
            </div>
            <div class="imgPhoto-title" v-else>说明：--</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { stockLogFindLastOne } from '@/api/domain/returnLease'
import { getOutInDetailsSensitive } from '@/api/domain/cars'

export default {
  inject: ['orderData'],
  data() {
    return {
      oLoading: {
        detail: false,
      },
      stockId: '',
      stockInfoVo: {},
      stockKeyList: [
        { key: 'actualTakeOverName', name: '提车人姓名' },
        { key: 'actualTakeOverTel', name: '提车人联系电话' },
        { key: 'managerName', name: '交接车管' },
        { key: 'displayMile', name: '表显里程' },
        { key: 'remainingReserves', name: '剩余电量/油量' },
        { key: 'takeOverTime', name: '验车完成时间' },
        { key: 'hasKey', name: '车钥匙' },
        { key: 'hasCarLicense', name: '行驶证' },
        { key: 'remarks', name: '备注', clone: true },
      ],
      enum: {
        hasKey: { 0: '无钥匙', 1: '有钥匙' },
        hasCarLicense: { 0: '无行驶证', 1: '有行驶证' },
      },
    }
  },
  created() {
    this.getStockId()
      .then((hasStock) => hasStock && this.getOutInDetails())
      // 接口错误由 request 拦截器提示，初始化失败时不再继续请求详情。
      .catch(() => undefined)
  },
  methods: {
    // 获取最新的出入库记录
    // 参数 {carId:车辆ID type：1出库 2入库, orderId: 订单ID}
    async getStockId() {
      const { carId, id } = this.orderData
      const { code, data } = await stockLogFindLastOne({
        carId,
        type: 2,
        orderId: id,
        sourceType: 1,
        sourceId: id,
      })
      if (code !== 1) return false
      this.stockId = data?.id
      return true
    },
    async getOutInDetails() {
      this.oLoading.detail = true
      const { code, data } = await getOutInDetailsSensitive({ id: this.stockId })
      if (code !== 1) return
      this.stockInfoVo = data.stockInfoVo
      this.stockInfoVo.displayMile = this.stockInfoVo.displayMile
        ? `${this.stockInfoVo.displayMile} 公里`
        : ''
      this.stockInfoVo.photo = this.imageFilter(data?.stockInfoVo?.photo)
      this.stockInfoVo.inspectionAttachment = this.imageFilter(data?.stockInfoVo?.inspectionAttachment)

      this.stockInfoVo.hasKey =
        this.stockInfoVo.hasKey || Number(this.stockInfoVo.hasKey) === 0
          ? this.enum.hasKey[this.stockInfoVo.hasKey]
          : ''
      this.stockInfoVo.hasCarLicense =
        this.stockInfoVo.hasCarLicense ||
        Number(this.stockInfoVo.hasCarLicense) === 0
          ? this.enum.hasCarLicense[this.stockInfoVo.hasCarLicense]
          : ''
      this.oLoading.detail = false
    },
    // 图片处理
    imageFilter(data) {
      if (!data) return []
      let result
      try {
        result = JSON.parse(data)
      } catch (error) {
        result = data
      }

      Array.isArray(result) && result.forEach((item) => {
        item.urlList = this.getEchoUploadFileData(item?.urlList, true)
      })
      return result || []
    },
  },
}
</script>

<style scoped lang="scss">
.title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  font-weight: 600;
  font-size: 16px;
  color: #323233;
  margin-bottom: 14px;
}
.imgPhoto {
  width: 80px;
  height: 80px;
  margin: 0 10px 5px 0;
}

.img-item {
  display: flex;
  margin-bottom: 10px;

  // min-height: 105px;
  .label {
    padding-right: 12px;
    width: 130px;
    text-align: right;
    box-sizing: border-box;
  }

  .content {
    max-width: 480px;
    display: flex;
    flex-wrap: wrap;

    .item {
      margin-left: 16px;
      width: 80px;

      &:nth-child(5n + 1) {
        margin-left: 0;
      }

      &:nth-child(n + 6) {
        margin-top: 6px;
      }
    }

    p {
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #969799;
      line-height: 25px;
      overflow: hidden;
      text-align: center;
    }
  }
}

.lh28 {
  line-height: 28px;
}

.car-details {
  height: 100%;

  .float-right {
    float: right;
  }

  .details-container {
    position: relative;
    height: calc(100% - 80px);
  }

  .file-list {
    padding-left: 0;
    list-style: none;

    li {
      display: flex;

      [class^='el-icon'] {
        width: 20px;
        line-height: 28px;
        color: #2e7eff;
        padding-right: 10px;
      }

      p {
        flex: 1;
        color: #2e7eff;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
}

.carPhoto-box {
  display: flex;
  margin: 10px 0 0 50px;

  // align-items: center;
  .carPhoto-title {
    width: 110px;
    color: #333;
  }
}

.photo-box {
  // display: flex;
  // flex-wrap: wrap;
  .photo-item {
    margin-bottom: 10px;
  }

  .imgPhoto-title {
    width: 40vw;
    word-break: break-all;
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
  }
}
</style>
